import { msg } from "@lingui/core/macro";

// Название типа сборки: плашка сборки и итог секции «Закуп». `kind` — `BuildKind` с бэкенда.
export const BUILD_KIND_TITLE = msg({
  id: "analysis.build.kind",
  message:
    "{kind, select, melee {Melee build} spirit {Spirit build} weapon {Gun build} other {Mixed build}}",
});
